import React from 'react'

import { labelsStore } from 'sdc-i18n-stores'

import { Rates } from './rates'

export const Brutto = () => <Rates caption={labelsStore.labelFor('planning.gross')} factor={1.19} />
